module.exports = __webpack_public_path__ + "media/product/i-1-71afe404.png";